/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function (event) {
  const variant = event.detail.variant;

  const isDiscontinued = (window.__PRODUCT_TAGS__ || []).includes("discontinued");
  const isMadeToOrder = (window.__PRODUCT_TAGS__ || []).includes("availability-MTO");

  const productInventoryElement = document.querySelector(".product-item__inventory");
  if (!productInventoryElement) return;

  // Safely read availability flag (element may not exist after re-render)
  const isAvailableEl = document.getElementById("availability_slow");
  const isSlow = isAvailableEl?.dataset?.availability === "true";

  // Remove old discontinued badge if it exists (avoid duplicates)
  document.querySelectorAll(".discontinued-badge").forEach(el => el.remove());

  // Reset
  productInventoryElement.classList.remove("inventory--high", "inventory--low");
  productInventoryElement.removeAttribute("id");
  productInventoryElement.style.marginBottom = "";
  productInventoryElement.style.color = "";
  productInventoryElement.innerHTML = "";

  // Render
  if (isDiscontinued) {
    const discontinuedBadge = document.createElement("div");
    discontinuedBadge.className = "discontinued-badge";
    discontinuedBadge.innerText = "Discontinued";
    discontinuedBadge.style.background = "#b00020";
    discontinuedBadge.style.color = "#fff";
    discontinuedBadge.style.padding = "4px 8px";
    discontinuedBadge.style.fontSize = "12px";
    discontinuedBadge.style.borderRadius = "4px";
    discontinuedBadge.style.marginBottom = "10px";
    productInventoryElement.before(discontinuedBadge);

    productInventoryElement.style.color = "rgb(120,120,120)";
    productInventoryElement.innerHTML = `Contact us for further information.`;
    return;
  }

  if (variant?.available) {
    if (isMadeToOrder) {
      productInventoryElement.classList.add("inventory--high");
      productInventoryElement.id = "available-orange";
      productInventoryElement.style.color = "#29615E";
      productInventoryElement.style.marginBottom = "14px";
      productInventoryElement.innerHTML = `Made to Order <div class="tooltip" id="inventory-tooltip">
        <span class="info-hover">i</span>
        <span class="tooltiptext">Manufacturing of this product begins after your order has been paid. Standard lead times of 2-5 days apply. Contact us if your order is urgent.</span>
      </div>`;
    } else if (isSlow) {
      productInventoryElement.classList.add("inventory--high");
      productInventoryElement.id = "available-orange";
      productInventoryElement.style.color = "#ff9307";
      productInventoryElement.style.marginBottom = "14px";
      productInventoryElement.innerHTML = `Subject to lead times <div class="tooltip" id="inventory-tooltip">
        <span class="info-hover">i</span>
        <span class="tooltiptext">Contact us for further information.</span>
      </div>`;
    } else {
      productInventoryElement.classList.add("inventory--high"); // (you had availability--high typo)
      productInventoryElement.id = "available-green";
      productInventoryElement.style.color = "#008a00";
      productInventoryElement.innerHTML = `In stock`;
    }
  } else {
    productInventoryElement.id = "inventory-soldout";
    productInventoryElement.style.marginBottom = "15px";
    productInventoryElement.style.color = "#000";
    productInventoryElement.innerHTML = `Sold out <div class="tooltip">
      <span class="info-hover">i</span>
      <span class="tooltiptext">Please contact us for alternative product suggestions and further information on the expected restock date.</span>
    </div>`;
  }
});

/* NND SMART BONDS SEARCH v1
 * Special predictive merchandising for Bo -> Bon -> Bond -> Bonds.
 * Keeps one Men's DACKS + one Women's DACKS + two BONDS products visible.
 * Random picks remain stable while the shopper stays inside this search intent.
 */
(function () {
  var smartPicks = null;

  function uniqueCandidates(root, role) {
    var seen = {};
    return Array.prototype.filter.call(
      root.querySelectorAll('[data-nnd-smart-product][data-nnd-role="' + role + '"]'),
      function (element) {
        var id = element.getAttribute('data-nnd-product-id');
        if (!id || seen[id]) return false;
        seen[id] = true;
        return true;
      }
    );
  }

  function shuffled(items) {
    var copy = items.slice();

    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }

    return copy;
  }

  function choose(root, role, count) {
    var candidates = uniqueCandidates(root, role);
    var previousIds = (smartPicks && smartPicks[role]) || [];
    var chosen = [];

    previousIds.forEach(function (id) {
      var match = candidates.find(function (candidate) {
        return candidate.getAttribute('data-nnd-product-id') === id;
      });

      if (match && chosen.length < count) chosen.push(match);
    });

    shuffled(candidates).forEach(function (candidate) {
      if (chosen.length >= count) return;

      var id = candidate.getAttribute('data-nnd-product-id');
      var alreadyChosen = chosen.some(function (selected) {
        return selected.getAttribute('data-nnd-product-id') === id;
      });

      if (!alreadyChosen) chosen.push(candidate);
    });

    candidates.forEach(function (candidate) {
      candidate.hidden = true;
    });

    chosen.forEach(function (candidate) {
      candidate.hidden = false;
    });

    smartPicks[role] = chosen.map(function (candidate) {
      return candidate.getAttribute('data-nnd-product-id');
    });
  }

  function applySmartSearch(root) {
    if (!smartPicks) {
      smartPicks = {
        'dacks-men': [],
        'dacks-women': [],
        'bonds': []
      };
    }

    choose(root, 'dacks-men', 1);
    choose(root, 'dacks-women', 1);
    choose(root, 'bonds', 2);

    root.setAttribute('data-nnd-smart-ready', 'true');
  }

  function scanSmartSearch() {
    var roots = document.querySelectorAll('[data-nnd-bonds-merchandising], [data-nnd-brand-merchandising], [data-nnd-category-dacks-merchandising]');

    if (!roots.length) {
      smartPicks = null;
      return;
    }

    Array.prototype.forEach.call(roots, applySmartSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanSmartSearch);
  } else {
    scanSmartSearch();
  }

  new MutationObserver(scanSmartSearch).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* NND BONDS TO DACKS SOLD OUT REDIRECT v1 */
(function () {
  function syncDacksRedirect(container, variant) {
    if (!container) return;
    var primaryCta = container.querySelector('[data-nnd-primary-cta]');
    var redirectCta = container.querySelector('[data-nnd-dacks-redirect]');
    if (!primaryCta || !redirectCta) return;

    var unavailable = variant
      ? variant.available === false
      : container.getAttribute('data-nnd-selected-available') === 'false';

    if (unavailable) {
      primaryCta.style.display = 'none';
      redirectCta.hidden = false;
      redirectCta.style.display = '';
    } else {
      primaryCta.style.display = '';
      redirectCta.hidden = true;
      redirectCta.style.display = 'none';
    }
  }

  function syncAllDacksRedirects(variant) {
    document.querySelectorAll('.product-form__payment-container[data-nnd-dacks-target]').forEach(function (container) {
      syncDacksRedirect(container, variant);
    });
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event && event.detail ? event.detail.variant : null;
    window.setTimeout(function () {
      syncAllDacksRedirects(variant);
    }, 0);
  });

  function initialiseDacksRedirects() {
    syncAllDacksRedirects(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseDacksRedirects);
  } else {
    initialiseDacksRedirects();
  }
})();
